const docTypeLabel = {
    ecn: "ECN",
    sop: "SOP",
    wi: "Work Instruction",
    fcd: "FCD",
    lit: "Literature",
};

const dynamicRoutes = [
    {
        pattern: /^\/dms\/edit\/(\w+)\/(.+)$/,
        resolve: (matches) => {
            const docType = docTypeLabel[matches[1]?.toLowerCase()]
                ?? matches[1]?.toUpperCase();
            const id = matches[2];
            return { title: `Edit ${docType} - #${id}`, pageTitle: "DMS" };
        }
    },
    {
        pattern: /^\/dms\/create\/(\w+)$/,
        resolve: (matches) => {
            const docType = docTypeLabel[matches[1]?.toLowerCase()]
                ?? matches[1]?.toUpperCase();
            return { title: `Create New ${docType}`, pageTitle: "DMS" };
        }
    },
    {
        pattern: /^\/task-management\/view-task\/(.+)$/,
        resolve: () => ({ title: "Task Details", pageTitle: "TaskManagement" })
    },
    {
        pattern: /^\/contract-review\/(.+)$/,
        resolve: () => ({ title: "Contract Review Details", pageTitle: "Contract Review" })
    },
    {
        pattern: /^\/epo\/(\d+)\/timeline$/,
        resolve: (matches) => ({
            title: `EPO #${matches[1]} Timeline`,
            pageTitle: "Operations"
        })
    },
];

export const getPageMeta = (pathname, routeMeta) => {
    // 1. Exact static match
    if (routeMeta[pathname]) return routeMeta[pathname];

    // 2. Dynamic pattern match ✅
    for (const route of dynamicRoutes) {
        const matches = pathname.match(route.pattern);
        if (matches) return route.resolve(matches);
    }

    // 3. Prefix fallback (existing behavior)
    const matchedKey = Object.keys(routeMeta).find(key =>
        pathname.startsWith(key)
    );

    return routeMeta[matchedKey] || { title: "", pageTitle: "" };
};
